import React from 'react';
import { LandingSvg } from 'assets';

export const INTEGRATIONS_THEMES = {
    DataCollection: {
        sectionBg: 'linear-gradient(180deg, rgba(245, 243, 255, 0.50) -233.52%, #FFF 100%)',
        accentColor: '#6941C6',
        badgeStyles: {
            color: '#7F56D9',
            backgroundColor: '#F4EBFF',
        },
        clearinghouseBg: 'linear-gradient(120deg, #FAF5FF -30.95%, #FCF8FF -24.49%, #FFFEFF 51.27%, #FFF 87.22%, #FFF 118.61%)',
        clearinghouseBorder: '1px solid #E9D7FE',
        tagBorder: '1px solid #F9F5FF',
    },
    PracticeManagement: {
        sectionBg: 'linear-gradient(180deg, #FFF -49.01%, rgba(239, 246, 255, 0.30) 25.49%, #FFF 100%)',
        accentColor: '#0948A1',
        clearinghouseBg: 'linear-gradient(135deg, #EFF6FF 25%, #FFF 95.71%)',
        clearinghouseBorder: '1px solid #BFDBFE',
        badgeStyles: {
            color: '#1D4ED8',
            backgroundColor: '#DBEAFE',
        },
        tagBorder: '1px solid #E7F0FC',
    },
};

export const integrations = [
    {
        name: 'Zoom',
        category: 'Telehealth',
        description: 'Launch and manage telehealth sessions seamlessly through Zoom.',
        Logo: <LandingSvg.ZoomCardSvg />,
    },
    {
        name: 'VB-MAPP',
        category: 'Clinical Assessments',
        description: 'Integrate VB-MAPP assessments into your clinical documentation workflows.',
        Logo: <LandingSvg.VbMappCardSvg />,
    },
    {
        name: 'Google Calendar',
        category: 'Scheduling Sync',
        description: 'Sync appointments and availability with Google Calendar in real time.',
        Logo: <LandingSvg.GCalendarCardSvg />,
    },
    {
        name: 'Office Ally',
        category: 'Claims & Billing',
        description: 'Submit claims and manage billing workflows directly through Office Ally.',
        Logo: <LandingSvg.OfficeAllyCardSvg />,
    },
    {
        name: 'Availity',
        category: 'Eligibility & Claims',
        description: 'Submit claims and manage billing workflows directly through Availity.',
        Logo: <LandingSvg.AvailityCardSvg />,
    },
    {
        name: 'Stripe',
        category: 'Payment Processing',
        description: 'Accept payments, automate invoicing, and manage revenue with Stripe.',
        Logo: <LandingSvg.StripeCardSvg />,
    },
];

export const clearinghouseFeatures = [
    'Claim Submissions',
    'Eligibility Checks',
    'Claim Status Checks',
    'ERA Automation',
];
